import { render, staticRenderFns } from "./AssessmentsEdit.vue?vue&type=template&id=748cad71"
import script from "./AssessmentsEdit.vue?vue&type=script&lang=js"
export * from "./AssessmentsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports